import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxOptions } from '@usitsdasdesign/dds-ng/checkbox';
import { FocusHandlerService } from '@usitsdasdesign/dds-ng/core/focus-handler';
import {  Themes, WidthState } from '@usitsdasdesign/dds-ng/shared';
import { DataContextService } from '../../../services/datacontext.service';
import * as _ from 'lodash';
import {  MultiselectGroup } from './multi-select-and-tag-item.interface';
import {ButtonKind, ButtonOptions } from '../button/button.component';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.less'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiSelectComponent),
    multi: true
  }]
})
export class MultiSelectComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() list: MultiSelectItem[] = [];
  @Input() tickAllDisplay: boolean = true;
  @Input() tickAllLabel: string = this.dataContextService.translateText('Translation.All');
  @Input() showChips: boolean = true;
  @Input() showIcon: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() label: string;
  @Input() isIncludeDeleted: boolean = false;
  @Input() includeDeletedValue: boolean;
  @Input() placeHolder: string = this.dataContextService.translateText('Translation.Select');
  @Input() errorMessage: string = '';
  @Input() isDisabled: boolean = false;
  @Input() showMoreLimit: number = 6;
  @Input() value:any;
  @Input() Reset:string;
  @Input() PreferenceInitialLoad:boolean=true;
  @Input() groups: MultiselectGroup[];
  @Input() key:string;
  showMore: boolean = false;
  all: MultiSelectItem = { label: this.tickAllLabel };
  opened: boolean = false;
  buttonOption: ButtonOptions = {
    kind: ButtonKind.primary,
  }
  BLUE_THEME = Themes.blue;
  chips: MultiSelectItem[] = [];
  @Output() selectedItems: EventEmitter<(string | number)[]> = new EventEmitter();
  @Output() includeDeleted: EventEmitter<boolean> = new EventEmitter();
  initialState: MultiSelectItem[] = [];
  get text(): string {
    if (this.list.every(i => i.isChecked == false)) {
      return this.placeHolder;
    }
    else if (this.list)
      return `${this.selected.length === this.list.length ? this.dataContextService.translateText('Translation.All') : `${this.selected.length}`} ${this.dataContextService.translateText('Translation.Preference_selected')}`;
    return `${this.dataContextService.translateText('Translation.Select')}`;
  }
  get limit(): number {
    if (this.showMore)
      return this.selected.length;
    return this.showMoreLimit;
  }
  get selected(): MultiSelectItem[] {
    return this.list.filter(i => i.isChecked);
  }
  onChange: any = () => {
  }
  onTouch: any = () => {
  }

  constructor(private dataContextService:DataContextService) { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges) {
    const { list, tickAllLabel } = changes;
    if (list && list.currentValue) {
      this.updateAllOption();
      this.updateChips();
    }
    if(this.value){
      this.writeValue(this.value);
    }
    if (tickAllLabel && tickAllLabel.currentValue)
      this.all = { ...this.all, label: tickAllLabel.currentValue };
      this.initialState = _.cloneDeep(list.currentValue); 
  }
  writeValue(obj: (number | string)[]): void {
    setTimeout(() => {
      if (this.list !== undefined) {
        if (obj) {
          if(this.groups){
            this.list.forEach(i => {
              i.isChecked = obj.filter((d: number | string) => d === i[this.key]).length ? true : false;
            });
          }
          else{
            this.list.forEach(i => {
              i.isChecked = obj.filter((d: number | string) => d === i.id).length ? true : false;
            });
          }
          this.updateAllOption();
          // this.emitSelectedDate()
          this.updateChips();
        }
      }
    })
  }

  private emitSelectedDate() {
    const selectedData = this.groups ? this.selected.map(i => i[this.key]) : this.selected.map(i => i.id);
    this.selectedItems.emit(selectedData);
  }
  private updateAllOption(groupId?:number) {
    if(groupId){
      const groupList = this.list.filter(i => i.groupId == groupId);
      const index = this.groups.findIndex(i => i.id == groupId)
      this.groups[index] = {
        ...this.groups[index],
        isAllChecked: groupList.some(i => i.isChecked) ? true : false,
        isAllIndeterminate: groupList.every(i => i.isChecked) || groupList.every(i => !i.isChecked) ? false : true
      }
    }

    this.all = {
      ...this.all,
      isChecked: this.list.some(i => i.isChecked) ? true : false,
      isIndeterminate: this.list.every(i => i.isChecked) || this.list.every(i => !i.isChecked) ? false : true
    }
    
    const selectedData = this.groups ? this.selected.map(i => i[this.key]) : this.selected.map(i => i.id);
    this.onChange(selectedData);
  }
  changeAllOption(state: boolean , groupId?:number) {
    this.onTouch();
    
    this.list = this.list.map(i => {
      return {
        ...i,
        isChecked:groupId? (groupId == i.groupId ? state : i.isChecked) : state 
      }
    });
    this.updateAllOption(groupId);
    this.emitSelectedDate()
    this.updateChips();
  }
  private updateChips() {
    this.chips = this.all.isIndeterminate ? this.selected : [];
  }
  changeItem(state: boolean, id: number , groupId?:number) {
    this.onTouch();
    if(groupId){
      this.list = this.list.map(i => {
        return {
          ...i,
          isChecked: id === i.id && groupId === i.groupId ? state : i.isChecked
        }
      });
    }
    else{
    this.list = this.list.map(i => {
      return {
        ...i,
        isChecked: id === i.id ? state : i.isChecked
      }
    });}
    this.updateAllOption(groupId);
    this.emitSelectedDate()
    this.updateChips();
    
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  stateChange(item) {
    this.includeDeleted.emit(item);
  }

  reset(){
   this.list = this.initialState;
   this.updateAllOption();
   this.emitSelectedDate()
   this.updateChips();
  }

  getGroupData(id){
    return this.list.filter(i => i.groupId == id);
  }

  allUnChecked(){
    if (this.list.every(i => i.isChecked == false)) {
      return true;
    }
  }
  
}
export interface MultiSelectItem extends CheckboxOptions {
  id?: number | string;
  isChecked?: boolean;
  icon?: string;
  groupId?:number;
 groupLabel?:string;
 [key: string]: any;
}
